import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SectorWeightings from "./SectorWeightings";
import FEFundSectorWeightingPanel from "@/components/fe/FEFundSectorWeightingPanel";
import FELookupEditor from "@/components/fe/FELookupEditor";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface Props {
  side: "p" | "r" | "dist" | "mm";
}

export default function FundSectorWeightingsTabs({ side }: Props) {
  const { staffMember, loading } = useAuth() as any;
  const isAdmin = staffMember?.role_level === "admin" || staffMember?.role_level === "superadmin";

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <Tabs defaultValue="manual" className="space-y-4">
      <TabsList>
        <TabsTrigger value="fe">FE-driven (CBAM)</TabsTrigger>
        <TabsTrigger value="manual">Manual mapping</TabsTrigger>
        {isAdmin && <TabsTrigger value="admin">FE Sector to CBAM Sector Lookup</TabsTrigger>}
      </TabsList>

      <TabsContent value="fe">
        <FEFundSectorWeightingPanel side={side} />
      </TabsContent>

      <TabsContent value="manual">
        <SectorWeightings side={side} />
      </TabsContent>


      {isAdmin && (
        <TabsContent value="admin" className="space-y-6">
          <FELookupEditor />
        </TabsContent>
      )}
    </Tabs>
  );
}
